// frontend/src/lib/hudlModel.js
// Display helpers shared by the Concierge Video tab and the Overview Hudl stats
// (spec docs/superpowers/specs/2026-10-09-concierge-hudl-video-design.md).
export const HUDL_STALE_DAYS = 30;

// Whole days elapsed, the way Hudl counts ("17 days ago"). The shared
// daysSince() counts local calendar days, which reads one more for a reel
// posted late in the evening (11:47 pm ET Sep 21 → 18 on Oct 9 morning).
function elapsedDays(iso, now) {
  const t = Date.parse(iso || '');
  return Number.isNaN(t) ? null : Math.floor((now - t) / 86400000);
}

export function hudlAgoText(iso, now = new Date()) {
  const n = elapsedDays(iso, now);
  if (n === null) return 'Never';
  if (n <= 0) return 'Today';
  if (n === 1) return 'Yesterday';
  return `${n} days ago`;
}

export function hudlUpdateTone(iso, now = new Date()) {
  const n = elapsedDays(iso, now);
  return n !== null && n > HUDL_STALE_DAYS ? 'amber' : 'ink';
}

const PROBLEMS = {
  no_link: 'No Hudl link',
  invalid_link: 'Link not readable',
  profile_not_found: 'Profile not found',
  private: 'Profile is private',
  hudl_unavailable: 'Hudl unavailable',
};
export const hudlProblem = (status) => PROBLEMS[status] || PROBLEMS.hudl_unavailable;

export function fmtDuration(ms) {
  const s = Math.round((ms || 0) / 1000);
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

export function shortMp4(url) {
  try {
    const u = new URL(url);
    return `${u.host}/…/${u.pathname.split('/').pop()}`;
  } catch (e) {
    return url || '';
  }
}
